import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorker';
import reportWebVitals from './reportWebVitals';
import { App } from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const {PUBLIC_URL} = process.env
// Normalize basename: ensure it starts with / and doesn't end with /
const basename = PUBLIC_URL 
  ? PUBLIC_URL.startsWith('/') 
    ? PUBLIC_URL.endsWith('/') 
      ? PUBLIC_URL.slice(0, -1) 
      : PUBLIC_URL
    : `/${PUBLIC_URL}`
  : ''
root.render(
  <React.StrictMode>
    <App basename={basename}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
